import { ConversionType } from "../../types/converter/conversionTypes";
import proj4 from "proj4";

const PT_TM06 =
  "+proj=tmerc " +
  "+lat_0=39.66825833333333 " +
  "+lon_0=-8.133108333333333 " +
  "+k=1 " +
  "+x_0=0 +y_0=0 " +
  "+ellps=GRS80 +units=m +no_defs";

const WGS84 = "+proj=longlat +datum=WGS84 +no_defs";

export const handleConvert = (value: number | [number, number], type: ConversionType) => {
  switch (type) {
    case "inches-mm":
      return (value as number) * 25.4;
    case "mm-inches":
      return (value as number) / 25.4;
    case "diameter-radius":
      return (value as number) / 2;
    case "radius-diameter":
      return (value as number) * 2;
    case "lh-ls":
      return (value as number) / 3600;
    case "ls-lh":
      return (value as number) * 3600;
    case "m3h-ls":
      return (value as number) / 3.6;
    case "ls-m3h":
      return (value as number) * 3.6;
    case "etrs89-wgs84":
      return proj4(
        PT_TM06,
        WGS84,
        value as [number, number]
      );

    case "wgs84-etrs89":
      return proj4(
        WGS84,
        PT_TM06,
        value as [number, number]
      );
    case "cv-kw":
      return (value as number) * 0.735499;

    case "kw-cv":
      return (value as number) / 0.735499;

    case "m3d-ls":
      return (value as number) / 86.4;

    case "ls-m3d":
      return (value as number) * 86.4;
    default:
      return 0;
  }
};

